const pl = {
  translation: {
    nav: {
      categories: "Kategorie",
      home: "Strona Główna",
    },
    hero: {
      tagline: "Największy Kakobuy Spreadsheet w Polsce",
      subtitle: "Ponad 20 000 produktów. Aktualizowany codziennie. 100% darmowy.",
      ctaPrimary: "Kakobuy Sheet",
      ctaSecondary: "Buy It Now",
      stats: {
        products: "20 000+",
        productsLabel: "Produktów",
        free: "100%",
        freeLabel: "Darmowe",
        verified: "Zweryfikowane",
        verifiedLabel: "QC Sprawdzone",
      },
    },
    categories: {
      title: "Kategorie Produktów",
      subtitle: "Przeglądaj wszystkie kategorie dostępne w naszym spreadsheetzie",
    },
    products: {
      title: "Popularne Produkty",
      subtitle: "Najczęściej wybierane przez naszą społeczność",
    },
    cta: {
      title: "Znajdź Swoje Wymarzone Produkty",
      subtitle: "Dołącz do tysięcy zadowolonych kupujących i odkryj najlepsze okazje na Kakobuy",
      button: "Buy It Now",
    },
    seo: {
      badge: "Przewodnik",
      title1: "Co to jest",
      title2: "Kakobuy Spreadsheet?",
      button: "Pełny przewodnik →",
    },
    footer: {
      subscribe: "Zapisz się",
      subscribeText: "Otrzymuj najnowsze aktualizacje i najlepsze okazje prosto na swoją skrzynkę.",
      subscribePlaceholder: "Twój adres email",
      subscribeButton: "Subskrybuj",
      navigation: "Nawigacja",
      contact: "Kontakt",
      address: "Adres",
      copyright: "© 2026 Kakobuy Finds Wiki. Wszelkie prawa zastrzeżone.",
      privacy: "Polityka prywatności",
      terms: "Regulamin",
    },
  },
};

export default pl;